<template>
  <fwa-record type="Manage FWA Record"></fwa-record>
</template>
    
<script>
import FwaRecord from "./FwaRecord.vue";
export default {
  components: {
    FwaRecord,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Fwa/ManageFwaRecord.vue